import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import Endpoints from "../../../domain/endpoints";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY} from "../../../base";
import { FetchState } from "../../../domain/models/fetch-state";
import { SearchHeadquarterType } from "../../../domain/models/unmapped-stockist/unmapped-stockist-data";
import { FetchSearchHeadquarter } from "../../../domain/useages/unmapped-stockist/fetch-search-headquarter";
import { RemoteFetchSearchHeadquarter } from "../../../data/usecases/unmapped-stockist/remote-fetch-search-headquarter";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface FetchSearchHeadquarterInterface {
  searchHeadquarter: SearchHeadquarterType[];
  fetchSearchHeadquarter: Function;
  clearSearchHeadquarter: Function;
}

const initialStates = {
  searchHeadquarter: [],
  searchHeadquarterState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useFetchsearchHeadquarterSlice: StateCreator<
  FetchSearchHeadquarterInterface
> = (set) => ({
  ...initialStates,
  fetchSearchHeadquarter: async (filters: FetchSearchHeadquarter.Params) => {
     const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
     const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remotesearchHeadquarter = new RemoteFetchSearchHeadquarter(
      `${BASE_URL}${Endpoints.SEARCH_HEADQUARTER}`,
      axiosHttpClient
    );

    let result = await remotesearchHeadquarter.fetch(filters);
    if (result) {
      set(() => ({
        searchHeadquarter: result,
      }));
    }
  },
  clearSearchHeadquarter: () => {
    set(() => ({ searchHeadquarter: [] }));
  },
});
